import styles from './styles.module.scss';

interface TextAreaProps extends React.HTMLAttributes<HTMLTextAreaElement> {
    value: React.ComponentState;
    rows?: number;
}

export const TextArea = ({ value, rows, ...rest }: TextAreaProps) => {
    return <textarea value={value} rows={rows} className={styles.textArea} {...rest} />;
};
